module.exports = function normalizeComponent (
  name,
  scriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  scriptExports = scriptExports || {}

  // ES6 modules interop
  var type = typeof scriptExports.default
  if (type === 'object' || type === 'function') {
    // check named exports
    if (process.env.NODE_ENV !== 'production') {
      if (Object.keys(scriptExports).some(function (key) {
        return key !== 'default' && key !== '__esModule'
      })) {
        console.error('named exports are not supported in *.vue files.')
      }
    }
    scriptExports = scriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // default name option based on filename
  if (options.name == null) {
    options.name = name
  }

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = options.computed || (options.computed = {})
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
  }

  return {
    exports: scriptExports,
    options: options
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/component-normalizer.js
// module id = 1
// module chunks = 0